import React from 'react';
import { Header } from 'web-library';

import { useHistory } from 'react-router-dom';
import { useHTMLFontSize } from '../hooks/fontSize';

const DefaultHeaderEmpty = () => {
  const { increaseFont, decreaseFont, isDisableDecrease, isDisableIncrease } = useHTMLFontSize();
  const history = useHistory();

  return (
    <Header
      locationUsed="CP"
      onClickSeabLogo={() => history.push('/')}
      isEmpty
      isDisableDecreaseButton={isDisableDecrease}
      isDisableIncreaseButton={isDisableIncrease}
      onClickDecreaseFont={decreaseFont}
      onClickIncreaseFont={increaseFont}
    />
  );
};
export default DefaultHeaderEmpty;
